// extracted by mini-css-extract-plugin
module.exports = {"Article":"Article_Article__3huuY","final":"Article_final__32mKl"};